import { Link } from "react-router-dom";
import type { ScheduleApplication, ScheduleInvitation } from "@models/Schedule";

interface Props {
	applications: ScheduleApplication[];
	invitations: ScheduleInvitation[];
	canBook: boolean;
	onBook: (application: ScheduleApplication) => void;
}

export const getConsultantName = (consultant: { firstName?: string; lastName?: string }) =>
	[consultant.firstName, consultant.lastName].filter(Boolean).join(" ") || "Konsult";

const tagClass = "rounded-sm px-1.5 py-0.5 text-[11px] font-semibold leading-none";

/**
 * Pending applications (and open invitations) for a job's unmanned shifts. Shows
 * the consultant's city and whether the customer has hired them before.
 */
const ApplicantList = ({ applications, invitations, canBook, onBook }: Props) => (
	<div className="flex flex-col gap-2">
		{applications.map((application) => (
			<div key={application.id} className="flex items-center justify-between gap-3">
				<div className="min-w-0">
					<div className="flex items-center gap-1.5">
						<Link
							to={`/konsultprofil/${application.consultant.id}`}
							className="truncate text-sm font-semibold text-gray-900 hover:underline"
						>
							{getConsultantName(application.consultant)}
						</Link>
						<span className={`${tagClass} bg-[#219CD0] text-white`}>Ansökt</span>
					</div>
					<div className="flex flex-wrap items-center gap-x-2 text-xs text-gray-500">
						{application.consultant.profile?.address?.city && <span>{application.consultant.profile.address.city}</span>}
						{application.consultant.hasCustomerExperience && (
							<span className="font-medium text-[#29A54D]">Tidigare anlitad</span>
						)}
					</div>
				</div>
				{canBook && (
					<button
						type="button"
						onClick={() => onBook(application)}
						className="shrink-0 cursor-pointer rounded-md !bg-[#29A54D] !px-3 !py-1 !text-sm font-semibold !text-white hover:opacity-90"
					>
						Boka
					</button>
				)}
			</div>
		))}
		{invitations.map((invitation) => (
			<div key={invitation.id} className="min-w-0">
				<div className="flex items-center gap-1.5">
					<span className="truncate text-sm font-semibold text-gray-900">{getConsultantName(invitation.consultant)}</span>
					<span className={`${tagClass} bg-orange-100 text-orange-700`}>Önskad</span>
				</div>
				<div className="flex flex-wrap items-center gap-x-2 text-xs text-gray-500">
					{invitation.consultant.profile?.address?.city && <span>{invitation.consultant.profile.address.city}</span>}
					{invitation.consultant.hasCustomerExperience && (
						<span className="font-medium text-[#29A54D]">Tidigare anlitad</span>
					)}
					<span>Inväntar svar</span>
				</div>
			</div>
		))}
	</div>
);

export default ApplicantList;
